import React from "react";
import { Link } from "react-router-dom";

const SemiHeader = () => {
  return (
    <div className="flex items-center md:justify-between justify-start bg-gray-300 px-5 py-1">
      <div className="flex items-center justify-between md:justify-start w-full">
        <input
          type="text"
          class="md:mr-16 mr-5 bg-gray-100 border border-gray-300 text-gray-900 text-lg rounded-lg focus:ring-blue-500 focus:border-blue-500 block xs:w-[100px] sm:w-[250px] md:w-[320px] p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500"
          placeholder="Type to Search"
        />
        <label
          className="bg-gray-200 h-fit py-2 px-2 rounded-full "
          htmlFor="my-modal"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-8 h-8"
          >
            <path
              fillRule="evenodd"
              d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z"
              clipRule="evenodd"
            />
          </svg>
        </label>
      </div>
      <div className="lg:flex hidden items-center ml-16 my-0 py-0">
        <button
          type="button"
          class="flex items-center text-orange-500 bg-gray-200 border-2 border-gray-300 hover:text-white hover:bg-orange-600 focus:ring-4 rounded-lg text-lg px-5 py-2 mr-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6"
          >
            <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
            <path
              fillRule="evenodd"
              d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z"
              clipRule="evenodd"
            />
          </svg>
          SUMMARY
        </button>

        <button
          type="button"
          class="flex items-center text-orange-500 bg-gray-200 border-2 border-gray-300 hover:text-white hover:bg-orange-600 focus:ring-4 rounded-lg text-lg px-5 py-2 mr-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6"
          >
            <path
              fillRule="evenodd"
              d="M8.25 6.75a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM15.75 9.75a3 3 0 116 0 3 3 0 01-6 0zM2.25 9.75a3 3 0 116 0 3 3 0 01-6 0zM6.31 15.117A6.745 6.745 0 0112 12a6.745 6.745 0 016.709 7.498.75.75 0 01-.372.568A12.696 12.696 0 0112 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 01-.372-.568 6.787 6.787 0 011.019-4.38z"
              clipRule="evenodd"
            />
            <path d="M5.082 14.254a8.287 8.287 0 00-1.308 5.135 9.687 9.687 0 01-1.764-.44l-.115-.04a.563.563 0 01-.373-.487l-.01-.121a3.75 3.75 0 013.57-4.047zM20.226 19.389a8.287 8.287 0 00-1.308-5.135 3.75 3.75 0 013.57 4.047l-.01.121a.563.563 0 01-.373.486l-.115.04c-.567.2-1.156.349-1.764.441z" />
          </svg>
          HR
        </button>

        <button
          type="button"
          class="flex items-center text-orange-500 bg-gray-200 border-2 border-gray-300 hover:text-white hover:bg-orange-600 focus:ring-4 rounded-lg text-lg px-5 py-2 mr-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6"
          >
            <path
              fillRule="evenodd"
              d="M2.25 5.25a3 3 0 013-3h13.5a3 3 0 013 3V15a3 3 0 01-3 3h-3v.257c0 .597.237 1.17.659 1.591l.621.622a.75.75 0 01-.53 1.28h-9a.75.75 0 01-.53-1.28l.621-.622a2.25 2.25 0 00.659-1.59V18h-3a3 3 0 01-3-3V5.25zm1.5 0v7.5a1.5 1.5 0 001.5 1.5h13.5a1.5 1.5 0 001.5-1.5v-7.5a1.5 1.5 0 00-1.5-1.5H5.25a1.5 1.5 0 00-1.5 1.5z"
              clipRule="evenodd"
            />
          </svg>
          IT
        </button>

        <button
          type="button"
          class="flex items-center text-orange-500 bg-gray-200 border-2 border-gray-300 hover:text-white hover:bg-orange-600 focus:ring-4 rounded-lg text-lg px-5 py-2 mr-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6"
          >
            <path
              fillRule="evenodd"
              d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 6a.75.75 0 00-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 000-1.5h-3.75V6z"
              clipRule="evenodd"
            />
          </svg>
          HISTORY
        </button>
      </div>
      {/* Modal */}

      <input type="checkbox" id="my-modal" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-lg">
          Add a new User
          </h3>
          <form action="" className="w-full">
            <div class="grid gap-1 md:grid-cols-2 mb-2">
              <div>
                <label
                  for="name"
                  class="block  text-sm font-medium text-gray-700"
                >
                  First Name
                </label>
                <input
                  type="text"
                  name="f-name"
                  id="f-name"
                  class="bg-gray-200 border border-gray-300 text-gray-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  w-full p-2.5 placeholder-gray-600"
                  placeholder="Abdullah"
                />
              </div>
              <div>
                <label
                  for="last_name"
                  class="block  text-sm font-medium text-gray-700"
                >
                  Last Name
                </label>
                <input
                  name="l-name"
                  type="text"
                  id="l-name"
                  class="bg-gray-200 border border-gray-300 text-gray-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  w-full p-2.5 placeholder-gray-600"
                  placeholder="Mubin"
                />
              </div>
            </div>
            <div className="mb-2">
              <label
                for="message"
                class="block  text-sm font-medium text-gray-700"
              >
                Your Message
              </label>
              <textarea
                id="message"
                rows="4"
                class="block p-2.5  w-full text-sm bg-gray-200 border border-gray-300 text-gray-600  rounded-lg focus:ring-blue-500 focus:border-blue-500 placeholder-gray-600"
                placeholder="Write your thoughts here..."
              ></textarea>
            </div>
            
           <div className="mb-2">
           <label
                for="message"
                class="block  text-sm font-medium text-gray-700"
              >
                Start Date
              </label>
              <input className="bg-gray-200 border border-gray-300 text-gray-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  w-full p-2.5 placeholder-gray-600" type="date" name="" id="" />
           </div>

            

            

            <div className="mb-2">
              <label
                for="last_name"
                class="block  text-sm font-medium text-gray-700"
              >
                Depertment
              </label>

              <select
                id="Sector"
                name="Sector"
                class="bg-gray-200 border border-gray-300 text-gray-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  w-full p-2.5 placeholder-gray-600 "
              >
                <option value="Marketing">Marketing</option>
                <option value="Development">Development</option>
              </select>
            </div>


            <div className="mb-2">
              <label
                for="last_name"
                class="block  text-sm font-medium text-gray-700"
              >
                Line Manager
              </label>

              <select
                id="Sector"
                name="Sector"
                class="bg-gray-200 border border-gray-300 text-gray-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  w-full p-2.5 placeholder-gray-600 "
              >
                <option value="TomCook">Tom Cook</option>
                <option value="John">John</option>
              </select>
            </div>


            <div className="">
              <label
                for="last_name"
                class="block  text-sm font-medium text-gray-700"
              >
                Region
              </label>

              <select
                id="Sector"
                name="Sector"
                class="bg-gray-200 border border-gray-300 text-gray-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  w-full p-2.5 placeholder-gray-600 "
              >
                <option value="India">India</option>
                <option value="England">England</option>
              </select>
            </div>

          </form>
          <div className="modal-action">
            <label htmlFor="my-modal" className="btn text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-3 mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
            Submit!
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SemiHeader;
